export enum UserActivationStatus {
  CheckingCode,
  LooksGood,
  RequireUserInput,
}
